// Shared constants/helpers for the Lead Management module.

// Brand accent (matches ConfigProvider colorPrimary in main.jsx).
export const BRAND = '#e27e56';

// Fallback priority colours (overridden by Settings -> priority_color when available)
export const PRIORITY_COLORS = {
  Hot: '#f5222d',
  Warm: '#fa8c16',
  Cold: '#1890ff',
  Lost: '#8c8c8c',
  Fake: '#722ed1',
  Converted: '#52c41a',
};

export const EXPECTED_UNITS = ['Days', 'Weeks', 'Months', 'Years'];

// Build a quick lookup map { value: color } from a settings category array.
export const colorMap = (list = []) =>
  list.reduce((acc, s) => { acc[s.Value] = s.Color; return acc; }, {});

// Lead age in whole days from a created date.
export const leadAgeDays = (createdAt) => {
  if (!createdAt) return 0;
  const ms = Date.now() - new Date(createdAt).getTime();
  return Math.max(0, Math.floor(ms / 86400000));
};

// Colour for the lead-score badge.
export const scoreColor = (score) => {
  if (score >= 70) return '#52c41a';
  if (score >= 40) return '#fa8c16';
  return '#8c8c8c';
};
